import { render, staticRenderFns } from "./CustomColourCard.vue?vue&type=template&id=02963e9e&"
import script from "./CustomColourCard.vue?vue&type=script&lang=js&"
export * from "./CustomColourCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports